import { useCallback } from 'react';
import { DateRangeFilterSelect } from '../../../commonUI/DateRangeFilterSelect/DateRangeFilterSelect';
import { StrictDateRange } from '../../../commonUI/DateRangeFilterSelect/types';
import { DateRangeKey } from '../../../commonUI/DateRangeFilterSelect/utils/generateDateRangeFilter';
import { useBlueberryReportDateRangeKeys } from '../hooks/useBlueberryReportDateRangeKeys';

type Props = {
  onChange: (value: StrictDateRange) => void;
  initialValue?: DateRangeKey;
};

export const ReportsDateRangeSelect = ({ onChange, initialValue }: Props) => {
  const dateRangeOptions = useBlueberryReportDateRangeKeys();

  const handleChange = useCallback(
    (range: StrictDateRange | null) => {
      if (range) {
        onChange(range);
      }
    },
    [onChange]
  );

  return (
    <DateRangeFilterSelect
      onChange={handleChange}
      options={dateRangeOptions}
      initialValue={initialValue}
    />
  );
};
